export default "__VITE_ASSET__ec14d4da__"